/**
 * useCityTheme — reflects the selected metro on `<html data-city="…">`.
 *
 * Accents remain UNIFIED at launch: every `[data-city]` block in index.css
 * resolves to the same master burnt-marigold, so this attribute is currently
 * cosmetic and produces no visual divergence. It tracks the metro (rather than
 * locking to "austin") so that when per-city accent palettes are switched on
 * later, the hook already feeds them the right city — no call-site changes.
 * The metro store stays the source of truth for data filtering.
 */
import { useEffect } from 'react';
import { useMetroStore } from '../stores/metroStore';

export function useCityTheme() {
  const selectedMetro = useMetroStore((s) => s.selectedMetro);
  useEffect(() => {
    const city = (selectedMetro || 'austin').toLowerCase();
    document.documentElement.setAttribute('data-city', city);
  }, [selectedMetro]);
}
